'use strict';

import { UAParser } from 'ua-parser-js';

/**
 * Environment
 */
class Environment {
  /**
   * Constructor of Environment.
   * @return {*}
   */
  constructor() {
    const ua = new UAParser().getResult();

    // public variables
    this.language = 'en';
    this.device = ua.device.type;
    this.platform = this._parsePlatform(this.device);
  }

  _parsePlatform(device) {
    switch (device) {
      case 'mobile':
      case 'tablet':
      case 'smarttv':
        return 'MOBILE_WEB';
      default:
        return 'WEB';
    }
  }
}
export default Environment;
